import React from 'react';
import { formatDateMMMMDYYYY, daysLeftFromToday } from '../utilities/commonUtilities/dateTools';
import { Container, Paper, Typography } from '@material-ui/core';
import { TaskHomeBetweenStyles as useStyles } from '../../styles/TaskHomeBetweenStyles';
import { TASK_HOME_BETWEEN_GREETING_TEXT } from '../../resources/messages.json';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import clsx from 'clsx';
import YourJourneyComponent from '../calendar/YourJourneyComponent';

export function computeGreetingInstForBetweenVisit(taskOpenDate) {
    const greetingText = TASK_HOME_BETWEEN_GREETING_TEXT;

    const onlyDayCount = true;
    const numOfDays = daysLeftFromToday(taskOpenDate, onlyDayCount);
    let until = '';
    if (numOfDays === 0) {
        until = 'today';
    } else if (numOfDays < 0) {
        until = 'soon';
    } else {
        until = `in ${numOfDays} days`;
    }

    const instructionText = `We'll see you ${until}!`;

    return {
        greetingText,
        instructionText,
    };
}

export function BetweenVisitSubPage({ taskOpenDate, allVisits, patientDiagnosisDate }) {
    const classes = useStyles();
    const bigMobileScreen = useMediaQuery('(min-width:516px) and (max-width:830px)');
    return (
        <>
            <Container
                className={clsx(classes.root, {
                    [classes.bigMobileScreen]: bigMobileScreen,
                })}
            >
                <Paper className={classes.taskBoard}>
                    <Typography variant="subtitle1" className={classes.h2Text}>
                        Next Routine Follow-up
                    </Typography>
                    <Typography>Tasks available on:</Typography>
                    <Paper className={classes.datePaper} elevation={0}>
                        <Typography variant="h2" className={classes.dateText}>
                            {formatDateMMMMDYYYY(taskOpenDate)}
                        </Typography>
                    </Paper>
                </Paper>
            </Container>
            <YourJourneyComponent visits={allVisits} patientDiagnosisDate={patientDiagnosisDate} />
        </>
    );
}
